export default function ContactForm () {
  redirectContactForm()
}

/**
 * Add redirects for cf7 forms, when form has been submitted and email sent
 */
function redirectContactForm () {
  const redirects = main_theme_objects.cf7_redirects

  if (redirects.length > 0) {
    document.addEventListener('wpcf7mailsent', function (event) {
      for (let i = 0; i < redirects.length; i++) {
        const redirect = redirects[i]
        if (parseInt(redirect.cf7_redirects_id) === event.detail.contactFormId) window.location.href = redirect.cf7_redirects_url
      }
    }, false)
  }
}
